import axios from "axios";
import paths from "./path";
let config = {
  // baseURL: "http://hivcampaign.gileadchina.cn",
  baseURL: "/phone/",
  timeout: 60 * 1000, // Timeout
  withCredentials: false // Check cross-site Access-Control
};
const _axios = axios.create(config);
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // console.log(error);
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    if (response.data.code == 200) {
      return Promise.resolve(response.data.data);
    } else {
      return Promise.reject(response.data);
    }
  },
  function(error) {
    // console.log(error);
    // Do something with response error
    return Promise.reject(error.message);
  }
);

function serialize(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}
const ajax = (path, params = {}) => _axios.post(paths[path], serialize(params));

export default ajax;
